//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
export default {
    components: {},
    props: [],
    data() {
        return {
            // 搜索部分
            formInline: {
                name: '',
                user: '',
                region: ''
            },
            regionData,
            regionProps: {
                value: "i",
                label: "n",
                children: "c",
            },
            checkedRegionData: [],
            form: {
                provinceName: '',
                cityName: '',
                areaName: '',
                provinceId: '',
                cityId: '',
                areaId: ''
            },
            //表格部分
            tableData: [

            ],

            //分页部分
            pagination: {
                page: 1,
                size: 10,
                total: 0,
            },
        };
    },
    mounted() {

    },
    created() {
        this.fn()
    },
    watch: {
        checkedRegionData(newVal) {
            this.form.provinceId = newVal[0] || "";
            this.form.cityId = newVal[1] || "";
            this.form.areaId = newVal[2] || "";
            let regionNames =
                newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
            this.form.provinceName = regionNames[0];
            this.form.cityName = regionNames[1];
            this.form.areaName = regionNames[2];

            console.log(this.form);
        },
    },
    methods: {

        //供应商列表

        fn() {
            let obj = {
                pageNum: this.pagination.page,
                pageSize: this.pagination.size,
                enterpriseName: ''
            }

            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res);
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },
        // 根据地区id查询name

        handleRegionName(ids) {
            let province = this.regionData.filter((item) => item.i == ids[0])[0];
            let city = province.c.filter((item) => item.i == ids[1])[0];
            let areaName = ids[2]
                ? city.c.find((item) => item.i == ids[2])
                    ? city.c.find((item) => item.i == ids[2]).n
                    : ""
                : "";
            return [province.n, city.n, areaName];
        },
        //查询

        onSubmit() {
            let obj = {
                pageNum: 1,
                pageSize: this.pagination.size,
                enterpriseName: this.formInline.name,
                linkPerson: this.formInline.user,
                cId: this.form.cityId,
                oId: this.form.areaId,
                pId: this.form.provinceId,
            }
            this.pagination.page = 1

            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res)
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },

        handleCurrentChange(val) {
            console.log(val)
            this.pagination.page = val
            let obj = {
                pageNum: val,
                pageSize: this.pagination.size,
                enterpriseName: this.formInline.name,
                linkPerson: this.formInline.user,
                cId: this.form.cityId,
                oId: this.form.areaId,
                pId: this.form.provinceId,
            }
            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res)
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },
        //清空

        handleReset() {
            this.formInline.name = ""
            this.formInline.user = ""
            this.form.cityId = ""
            this.form.areaId = ""
            this.form.provinceId = ""
            this.checkedRegionData = []
            this.fn()
        },

        //查看操作

        lookDetail(val) {
            this.$router.push({ path: './EnterDetail', query: { ids: val.id.toString() } })
        },

        //修改操作

        amend(val) {
            this.$router.push({ path: './EnterAmend', query: { ids: val.id.toString() } })
        },

    },
};
